<template>
  <div class="view-product-register-submodule">
    <div class="register-submodule-header">
      <snow-steps v-model="currentStep" :steps="steps" />
      <div class="d-flex gap-2">
        <snow-button
          :text="currentStep === 1 ? 'Cancelar' : 'Voltar'"
          variant="gray"
          @click="back"
        />
        <div class="d-lg-flex d-none gap-2">
          <snow-button
            v-if="currentStep === 2"
            text="Salvar rascunho"
            variant="outline"
            :disabled="!isValid"
            @click="saveAsDraft"
          />
          <snow-button
            v-if="currentStep === 2"
            text="Salvar e criar novo"
            variant="outline"
            :disabled="!isValid"
            @click="next((createNew = true))"
          />
        </div>
        <snow-button
          :text="currentStep === steps.length ? 'Salvar' : 'Próximo'"
          :disabled="!isValid"
          @click="next((createNew = false))"
        />
      </div>
      <div class="d-lg-none gap-2">
        <snow-button
          v-if="currentStep === 2"
          text="Salvar rascunho"
          variant="outline"
          :disabled="!isValid"
          @click="saveAsDraft"
        />
        <snow-button
          v-if="currentStep === 2"
          text="Salvar e criar novo"
          variant="outline"
          :disabled="!isValid"
          @click="next((createNew = true))"
        />
      </div>
    </div>
    <div class="register-submodule-content">
      <div v-if="currentStep === 1">
        <register-sub-module-basic
          :product-id="$route.params.id"
          :form="form"
        />
      </div>
      <div v-if="currentStep === 2">
        <register-sub-module-customization
          :product-id="$route.params.id"
          :form="form"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RegisterSubModuleBasic from "@/components/product/details/content/RegisterSubModuleBasic";
import RegisterSubModuleCustomization from "@/components/product/details/content/RegisterSubModuleCustomization";
import { formFields } from "@/functions/helpers";
import MemberAreaMixin from "@/mixins/memberArea.js";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  mixins: [MemberAreaMixin],
  components: {
    RegisterSubModuleCustomization,
    RegisterSubModuleBasic
  },
  computed: {
    ...mapState("membersModules", ["module"]),
    ...mapState("product", ["product"]),
    subModuleTitle() {
      return this.$route.params?.submodule_id
        ? "Editando Submódulo"
        : "Novo Submódulo";
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          link: "product-member-area-modules",
          title: "Conteúdo"
        },
        {
          link: "product-member-area-modules-detail",
          params: {
            id: this.$route.params.id,
            module_id: this.$route.params.module_id
          },
          title: "Módulo"
        },
        {
          title: this.$route.params?.submodule_id
            ? get(this.module, "name", "Editar Submódulo")
            : "Novo Submódulo"
        }
      ];
    },
    isValid() {
      return this.form.name;
    }
  },
  data() {
    return {
      currentStep: 1,
      steps: ["Informações básicas", "Personalização"],
      createNew: false,
      ...formFields(
        [
          "name",
          "picture",
          "cover_mobile",
          "header",
          "product_id",
          "parent",
          "days_to_release",
          "release_at"
        ],
        {
          parent: this.$route.params.module_id,
          product_id: this.$route.params.id
        }
      ),
      nav: "info",
      params: {
        product_id: this.$route.params.id,
        module_id: this.$route.params.module_id,
        limit: 1000,
        offset: 0
      },
      loading: false,
      search: "",
      editedIndex: null,
      actions: [
        {
          text: "Editar módulo",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            text: "Deseja mesmo excluir este módulo?"
          },
          event: "remove"
        }
      ]
    };
  },
  mounted() {
    if (this.$route.params.submodule_id) {
      this.dispatch();
    }
  },
  methods: {
    saveOrder() {
      this.$store.dispatch("membersModules/reorder", this.module.sub_modules);
    },
    editmodule(module) {
      this.$router.push({
        name: "product-members-module-edit",
        params: { module_id: module.id }
      });
    },
    removemodule(module) {
      this.$store.dispatch("membersModules/deleteSub", module.id).then(() => {
        this.$store.dispatch("membersModules/getDetails", this.module.id);
        this.$message.success("Submódulo apagado.");
      });
    },
    searching(v) {
      this.search = v;
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("membersModules/getDetails", this.$route.params.submodule_id)
        .then(data => {
          this.form = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      this.loading = true;

      if (!this.form.header) {
        this.$message.error("Adicione a capa horizontal.");
        return;
      }

      if (!this.form.cover_mobile) {
        this.$message.error("Adicione a capa mobile.");
        return;
      }

      if (!this.form.picture) {
        this.$message.error("Adicione o cartaz vertical.");
        return;
      }

      const data = {
        ...this.form,
        product_id: this.params.product_id,
        picture_mobile: this.form.cover_mobile
      };
      let action = "membersModules/post";

      if (this.$route.params.submodule_id) {
        data.id = this.$route.params.submodule_id;
        action = "membersModules/putSub";
      }

      if (!this.days_to_release) {
        data.days_to_release = 0;
      }

      data.release_at = this.form.release_at || null;

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          if (this.createNew) {
            this.$router.go(0);
          } else {
            this.$router.go(-1);
          }
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      if (this.currentStep === 1) {
        this.$router.go(-1);
      } else {
        this.currentStep--;
      }
    },
    saveAsDraft() {
      this.form.status = "draft";
      this.submit();
    },
    next() {
      if (this.currentStep === this.steps.length) {
        this.form.status = "published";
        this.submit();
      } else {
        this.currentStep++;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.view-product-register-submodule {
  .register-submodule-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 28px;
  }
  .register-submodule-content {
    background: var(--bg-2);
    border-radius: 16px;
    padding: 24px;
  }

  .name {
    color: rgba(59, 59, 74, 0.9);
    font-size: 14px;
    font-weight: 400;
  }
  .handle {
    cursor: grab;
  }
  .icon-angle-right,
  .icon-angle-left {
    font-size: 18px;
    margin-bottom: 1px;
    font-weight: 900;
  }
  .title {
    font-size: 18px !important;
    font-weight: 400;
  }
}
</style>
